import { logger } from '../../services/logger';
import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db, getTenantDoc } from '../../firebase/config';
import { getDoc } from 'firebase/firestore';
import { Box, CircularProgress } from '@mui/material';

import { Helmet } from 'react-helmet-async';

const AdminRoute = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(null); // null = loading
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                try {
                    // Check Firestore account document for admin role
                    const accountDoc = await getDoc(getTenantDoc(db, 'accounts', currentUser.uid));
                    setIsAdmin(accountDoc.exists() && accountDoc.data().role === 'admin');
                } catch (e) {
                    logger.error("Error checking admin status", e);
                    setIsAdmin(false);
                }
            } else {
                setIsAdmin(false);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress aria-label="Verifying admin access..." />
            </Box>
        );
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            {children}
        </>
    );
};

export default AdminRoute;
